<template>
    <div>
      <h3 class="text-lg font-[500] mb-4">All Available Routes</h3>
      <div>
           <div class="flex gap-3 items-center py-2 my-1">
             <input type="checkbox" class="checkbox" />
             <span>Lagos to Abuja</span>
           </div>
           <div class="flex gap-3 items-center py-2 my-1">
             <input type="checkbox" class="checkbox" />
             <span>Lagos to Abuja</span>
           </div>
           <div class="flex gap-3 items-center py-2 my-1">
             <input type="checkbox" class="checkbox" />
             <span>Lagos to Abuja</span>
           </div>


           <div class="flex justify-end mt-5">
               <button class="py-2 px-4 bg-primary-lightblue text-sm">Next</button>
           </div>
      </div>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>
.checkbox {
  display: initial;
  width: 1.2rem;
  height: 1.2rem;
  @apply accent-primary-yellow
}
.checkbox:checked{
    @apply bg-primary-yellow
}
</style>